import { atom } from 'recoil'
import { MESSAGE_BOX_VARIANT_WARNING } from 'mailup-web-components'

export const pageState = atom({
  key: 'SMTPPlusSendStatusPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: MESSAGE_BOX_VARIANT_WARNING
  }
})
